import { SCHEMA } from './constants'

export const handleScaleDataTable = (data = [], headers = []) => {
  const result = {}

  Object.values(SCHEMA).forEach((item) => {
    result[item.key] = {
      ...item,
    }
  })

  headers.forEach(({ key }) => {
    const { scaleData = {} } = data.find(({ year }) => year === key) || {}

    Object.values(SCHEMA).forEach((item) => {
      result[item.key][key] = {
        value: scaleData[item.key],
        growth: scaleData[item.growthKey],
      }
    })
  })

  return result
}
